
import React from 'react';
import { Card } from '@/components/ui/card';
import { TrendingUp, Eye, Gamepad as GamepadIcon, Clock, Star, AlertCircle } from 'lucide-react';

const StatCardsGrid = ({ analytics }: { analytics: any }) => {
  const statsCards = [
    { 
      label: 'Total Games (All-Time)', 
      value: analytics?.totalGames || 0, 
      icon: GamepadIcon, 
      color: 'bg-blue-500',
    },
    { 
      label: 'Real Plays (Period)', 
      value: analytics?.totalRealPlays?.toLocaleString() || '0', 
      icon: Eye, 
      color: 'bg-green-500',
      warning: !analytics?.hasData && analytics?.dateRange?.from && analytics?.dateRange?.to,
    },
    { 
      label: 'Display Plays (All-Time)', 
      value: analytics?.totalDisplayPlays?.toLocaleString() || '0', 
      icon: TrendingUp, 
      color: 'bg-purple-500',
    },
    { 
      label: 'Avg. Rating (All-Time)', 
      value: analytics?.avgRating || '0.0', 
      icon: Star, 
      color: 'bg-yellow-500',
    },
    { 
      label: 'Playtime (Period)', 
      value: `${analytics?.totalPlaytimeHours || '0'}h`, 
      icon: Clock, 
      color: 'bg-teal-500',
      warning: !analytics?.hasData && analytics?.dateRange?.from && analytics?.dateRange?.to,
    },
  ];

  return (
    <div className="space-y-4">
      {!analytics?.hasData && analytics?.dateRange?.from && analytics?.dateRange?.to && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-center gap-3">
          <AlertCircle className="w-5 h-5 text-yellow-600" />
          <div>
            <p className="text-sm font-medium text-yellow-800">No session data found for the selected period</p>
            <p className="text-xs text-yellow-600 mt-1">
              This might indicate no user activity during this time range, or the selected dates are in the future.
            </p>
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
        {statsCards.map((stat, index) => (
          <Card key={index} className={`p-4 sm:p-6 ${stat.warning ? 'border-yellow-200 bg-yellow-50' : ''}`}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs sm:text-sm font-medium text-gray-600">{stat.label}</p>
                <p className="text-xl sm:text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
                {stat.warning && (
                  <p className="text-xs text-yellow-600 mt-1">No data for period</p>
                )}
              </div>
              <div className={`p-2 sm:p-3 rounded-xl ${stat.color} text-white`}>
                <stat.icon className="w-4 h-4 sm:w-5 sm:h-5" />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default StatCardsGrid;
